(function () {
    const initSlider = () => {
        let productSlider;
        const productSliders = document.querySelectorAll('.product-article-card__swiper');
        productSliders.forEach((slider, index) => {
            productSlider = new Swiper(slider, {
                navigation: {
                    nextEl: ".product-article-card__button-next",
                    prevEl: ".product-article-card__button-prev",
                },
                slidesPerView: 2,
                slidesPerGroup: 1,
                spaceBetween: 8,
                watchSlidesProgress: true,
                on: {
                    init: function () {
                        this.navigation.init();
                        const prevButton = this.navigation.prevEl;
                        if (prevButton) {
                            prevButton.classList.add('swiper-button-disabled');
                        }
                    }
                }
            });
        });
    };
    const destroySlider = () => {
        const productSliders = document.querySelectorAll('.product-article-card__swiper');
        productSliders.forEach((slider, index) => {
            if (slider.swiper !== undefined) slider.swiper.destroy();
        });
    };
    const initSection = () => {
        const sections = document.querySelectorAll('.product-section');
        const sectionResizeObserver = new ResizeObserver((entries) => {
            destroySlider();
            initSlider();
        });
        destroySlider();
        initSlider();
        sections.forEach(item => {
            sectionResizeObserver.observe(item);
        });
    };
    initSection();
    document.addEventListener('shopify:section:load', function () {
        initSection();
    });
})();